export default __webpack_public_path__ + "static/media/carbohydrates.7b071b17.jpg";